import React, { createContext, useContext, useEffect, useState } from 'react';
import axiosInstance from '../api/axiosInstance';

const StoreSettingsContext = createContext(null);

export const StoreSettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState({
    loginToSeePrices: false,
    loginToAddToCart: false,
    showOutOfStockProducts: true,
    currencySymbol: 'GHS',
    storeName: 'Aurora Seafood',
    storePhone: '',
    storeEmail: '',
    whatsappNumber: '',
  });
  const [loading, setLoading] = useState(true);
  const [isLoggedIn, setIsLoggedIn] = useState(
    !!localStorage.getItem('aurora_token')
  );

  useEffect(() => {
    fetchSettings();
    const syncAuth = () => {
      setIsLoggedIn(!!localStorage.getItem('aurora_token'));
    };
    window.addEventListener('storage', syncAuth);
    window.addEventListener('focus', syncAuth);
    // Also poll every second for cross-tab sync
    const interval = setInterval(syncAuth, 1000);
    return () => {
      window.removeEventListener('storage', syncAuth);
      window.removeEventListener('focus', syncAuth);
      clearInterval(interval);
    };
  }, []);

  const fetchSettings = async () => {
    try {
      const response = await axiosInstance.get('/store-settings');
      if (response.data.success) {
        setSettings(response.data.data);
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const showPrice = !settings.loginToSeePrices || isLoggedIn;
  const canAddToCart = !settings.loginToAddToCart || isLoggedIn;

  return (
    <StoreSettingsContext.Provider value={{
      settings,
      loading,
      isLoggedIn,
      showPrice,
      canAddToCart,
    }}>
      {children}
    </StoreSettingsContext.Provider>
  );
};

export const useStoreSettings = () => useContext(StoreSettingsContext);